import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Cards from "@/components/Cards.vue";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import Stats from "@/components/Stats.vue";
import Log from "@/components/Log.vue";
import { useGameStateStore } from "@/store/gameState";
import { GameState } from "@/store/constants";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

const state = useGameStateStore();

const layoutClassName = "layout";

const classNames = computed(() => [
  layoutClassName,
  {
    [`${layoutClassName}_win`]:
      state.gameState === GameState.gameOver && state.win,
    [`${layoutClassName}_loose`]:
      state.gameState === GameState.gameOver && !state.win,
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classNames))
  }, [
    _createElementVNode("div", null, [
      _createVNode(Header),
      _createElementVNode("main", null, [
        _createVNode(Cards),
        _createVNode(Log)
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(Stats),
      _createVNode(Footer)
    ])
  ], 2))
}
}

})